import { connect } from 'react-redux';

import { actionCreateAdministratorPassword } from 'store/administrator/actions';
import CreatePassword from './CreatePassword';

const mapStateToProps = (state) => ({
  isLoadingCreateAdministratorPassword: state.Administrator.isLoadingCreateAdministratorPassword,
});

const mapDispatchToProps = (dispatch) => ({
  actionCreateAdministratorPassword: (
    payload,
  ) => dispatch(actionCreateAdministratorPassword(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePassword);
